import script from "./goRinSyo0058.vue?vue&type=script&setup=true&lang=js"
export * from "./goRinSyo0058.vue?vue&type=script&setup=true&lang=js"

import "./goRinSyo0058.vue?vue&type=style&index=0&id=1d68fe0e&lang=scss"

const __exports__ = script;

export default __exports__